module.exports = __webpack_public_path__ + "media/images/calltoaction-1f2291c0af86c2188be6889ad79fb50d.jpg";